import BouncingImage from '@/components/bouncingImage'
import DownloadApps from '@/components/downloadApps'
import FeatureItem from '@/components/featureItem'
import LayoutWithNavigation from '@/components/layoutWithNavigation'
import PageHeader from '@/components/pageHeader'
import Picture from '@/components/picture'
import { appList, featureList, STRINGS } from '@/constants/farmIntelligence'

export async function getStaticProps() {
  return {
    props: {
      title: STRINGS.PAGE_TITLE,
      description: STRINGS.PAGE_DESCRIPTION,
    },
  }
}

const FarmIntelligence = () => (
  <LayoutWithNavigation>
    <section className="px-6 my-4 max-w-7xl m-auto">
      <PageHeader
        heading={STRINGS.PAGE_HEADING}
        subHeading={STRINGS.SUB_HEADING}
      />
      <section className="flex md:flex-row flex-col">
        <div className="md:flex-1 pt-4">
          <p className="whitespace-pre-wrap mb-2.5 text-footer-grey text-base font-natosans-light">
            {STRINGS.DESCRIPTION}
          </p>
          <div className="py-2.5">
            <DownloadApps apps={appList} />
          </div>
        </div>
        <div className="md:w-1/3 md:px-4 py-2.5">
          <Picture
            image="/assets/images/farm-intelligence/ai-random-graphs"
            imageAlt="AI ML random graphs"
            loading="eager"
            imageStyle="w-full"
          />
        </div>
      </section>
    </section>
    <section className="bg-[#081621] py-[30px] mt-[50px]">
      <div className="px-6 max-w-7xl m-auto pt-2.5">
        <h2 className="text-white text-[45px] leading-normal font-natosans-medium tracking-[2px] mt-5 mb-2.5">
          {STRINGS.BENEFITS}
        </h2>
        <div className="flex md:flex-row flex-col">
          <ul className="md:w-1/2 md:px-4">
            {featureList.map(({ key, ...feature }) => (
              <li key={key}>
                <FeatureItem
                  {...feature}
                  titleStyle="text-[#6bb51e] text-xl my-2.5"
                  descriptionStyle="text-white text-sm mb-2.5"
                  imageContainerStyle="pt-4 mt-2.5"
                  imageStyle="w-[75px] aspect-square"
                />
              </li>
            ))}
          </ul>
          <div className="md:w-1/2 md:px-8 md:mt-0 mt-2">
            <BouncingImage
              image="/assets/images/farm-intelligence/online-portal"
              imageAlt={STRINGS.PAGE_HEADING}
            />
          </div>
        </div>
      </div>
    </section>
  </LayoutWithNavigation>
)

export default FarmIntelligence
